import React from "react";
import {Brands} from "@core-ui/utility";
import {Icon} from "../components/Icon";
import {IconContainerProps} from "../types";

const CrossBrandSVG = (
  <svg fill="none" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
    <path
      clipRule="evenodd"
      d="M.614258 15.7714C.614258 7.08569 7.58569.114258 16.2714.114258 24.8428.114258 31.7 7.19997 31.7 15.7714c0 8.5714-6.9715 15.5429-15.5429 15.5429-8.57141 0-15.542842-6.8572-15.542842-15.5429zm19.771442 1.6l2.6286-2.5143c.2285-.2286.3428-.6857.2285-1.0286-.2285-.3428-.4571-.5714-.9143-.6857l-3.5428-.5714-1.7143-3.31429c-.1143-.34285-.5714-.57142-.9143-.57142-.3428 0-.6857.22857-.9143.57142l-1.6 3.19999-3.5428.5714c-.45717 0-.80003.3429-.91431.6858-.11429.4571-.11429.9142.22857 1.1428l2.62854 2.6286-.5714 3.5428c0 .3429.1143.8.4571 1.0286.3429.2286.8.3429 1.1429.1143l3.0857-1.8286 3.2 1.7143c.1143.1143.2286.1143.4572.1143.2285 0 .4571-.1143.6857-.2286.3428-.2285.5714-.5714.4571-1.0285l-.5714-3.5429z"
      fill="#000"
      fillRule="evenodd"
    />
  </svg>
);

const brandIconSVGs = {
  [Brands.Athleta]: CrossBrandSVG,
  [Brands.BananaRepublic]: CrossBrandSVG,
  [Brands.BananaRepublicFactoryStore]: CrossBrandSVG,
  [Brands.Gap]: CrossBrandSVG,
  [Brands.GapFactoryStore]: CrossBrandSVG,
  [Brands.OldNavy]: CrossBrandSVG,
  crossBrand: CrossBrandSVG,
};

export const ValueDrawerRewardsIcon = (
  props: IconContainerProps
): JSX.Element => <Icon {...props} brandIconSVGs={brandIconSVGs} />;
